import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import * as reactSpark from 'react-spark';
import InputField from '../../input-field/InputField';

const { Stack } = reactSpark;

class ConfiguredDate extends Component {
    daysInMonth(month, year) {
        switch (month) {
            case 2:
                return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0 ? 29: 28;
            case 4: case 6: case 9: case 11:
                return 30;
            default:
                return 31;
        }
    }

    isValidDate(month, day, year) {
        return month > 0 && month <= 12 && day > 0 && day <= this.daysInMonth(month, year);
    }

    monthValidation = {
        message: {
            default: 'Enter a month',
            pattern: {
                notNumber: 'Month must be entered as a number',
                invalid: 'Not a valid month',
            },
            required: 'This field is required'
        },
        required: true,
        validateOn: 'blur',
        checkValidity: (val) => {
            let month = Number(val);
            if (Number.isNaN(month)) {
                return {
                    isValid: false,
                    inputAttr: {
                        pattern: 'notNumber'
                    }
                };
            }
            if (month < 1 || month > 12 || val.includes('.')) {
                return {
                    isValid: false,
                    inputAttr: {
                        pattern: 'invalid'
                    }
                };
            }
            return true;
        }
    };

    dayValidation = {
        message: {
            default: 'Enter a day',
            pattern: {
                notNumber: 'Day must be entered as a number',
                invalid: 'Not a valid day',
            },
            required: 'This field is required'
        },
        required: true,
        validateOn: 'blur',
        checkValidity: (val, dependentVals) => {
            let day = Number(val);
            if (Number.isNaN(day)) {
                return {
                    isValid: false,
                    inputAttr: {
                        pattern: 'notNumber'
                    }
                };
            }
            if (dependentVals[`${this.props.name}Month`] && dependentVals[`${this.props.name}Year`]) {
                let monthString = dependentVals[`${this.props.name}Month`];
                let yearString = dependentVals[`${this.props.name}Year`];
                let month = Number(monthString);
                let year = Number(yearString);
                if (!Number.isNaN(month) && !Number.isNaN(year) && !(month < 1 || month > 12) && !(year < this.props.minyear || year > this.props.maxyear) && !monthString.includes('.') && !val.includes('.') && !yearString.includes('.')) {
                    if (!this.isValidDate(month, day, year)) {
                        return {
                            isValid: false,
                            inputAttr: {
                                pattern: 'invalid'
                            }
                        };
                    }
                }
            }
            if (day < 1 || day > 31 || val.includes('.')) {
                return {
                    isValid: false,
                    inputAttr: {
                        pattern: 'invalid'
                    }
                };
            }
            return true;
        }
    };

    yearValidation = {
        message: {
            default: 'Enter a year',
            pattern: {
                notNumber: 'Year must be entered as a number',
                belowMin: 'Year cannot be less than ' + this.props.minyear,
                aboveMax: 'Year cannot be greater than ' + this.props.maxyear,
                invalid: 'Not a valid year',
            },
            required: 'This field is required',
        },
        required: true,
        validateOn: 'blur',
        checkValidity: (val) => {
            let year = Number(val);
            if (Number.isNaN(year)) {
                return {
                    isValid: false,
                    inputAttr: {
                        pattern: 'notNumber'
                    }
                };
            }
            if (val.includes('.')) {
                return {
                    isValid: false,
                    inputAttr: {
                        pattern: 'invalid'
                    }
                };
            }
            if (year < this.props.minyear) {
                return {
                    isValid: false,
                    inputAttr: {
                        pattern: 'belowMin'
                    }
                };
            }
            if (year > this.props.maxyear) {
                return {
                    isValid: false,
                    inputAttr: {
                        pattern: 'aboveMax'
                    }
                };
            }
            return true;
        }
    }

    render() {
        const {
            day,
            disabled,
            includeday,
            id,
            month,
            name,
            placeholder,
            spacing,
            year,
        } = this.props;

        const dependentFields = includeday ? [name + 'Day'] : [];

        return (
            <Fragment>
                {placeholder &&
                    <label className='sprk-b-Label'>{placeholder}</label>
                }
                <Stack
                    splitAt='tiny'
                    itemSpacing={spacing}
                >
                    <Stack.Item width='flex' breakpoint='tiny'>
                        <InputField
                            id={id + 'Month'}
                            name={name + 'Month'}
                            disabled={disabled}
                            validation={this.monthValidation}
                            placeholder='Month (MM)'
                            dependentFields={dependentFields}
                            value={`${month}`}
                        />
                    </Stack.Item>
                    { includeday && (
                    <Stack.Item width='flex' breakpoint='tiny'>
                        <InputField
                            id={id + 'Day'}
                            name={name + 'Day'}
                            disabled={disabled}
                            validation={this.dayValidation}
                            placeholder='Day (DD)'
                            value={`${day}`}
                        />
                    </Stack.Item>
                    )}
                    <Stack.Item width='flex' breakpoint='tiny'>
                        <InputField
                            id={id + 'Year'}
                            name={name + 'Year'}
                            disabled={disabled}
                            validation={this.yearValidation}
                            placeholder='Year (YYYY)'
                            dependentFields={dependentFields}
                            value={`${year}`}
                        />
                    </Stack.Item>
                </Stack>
            </Fragment>
        );
    }
}

ConfiguredDate.defaultProps = {
    disabled: false,
    includeday: true,
    maxyear: new Date().getFullYear(),
    minyear: 1900,
    spacing: 'medium',
}

ConfiguredDate.propTypes = {
    day: PropTypes.string,
    disabled: PropTypes.bool,
    includeday: PropTypes.bool,
    maxyear: PropTypes.number,
    minyear: PropTypes.number,
    month: PropTypes.string,
    placeholder: PropTypes.string,
    spacing: PropTypes.string,
    year: PropTypes.string,
}

export default ConfiguredDate; 